import styled from 'styled-components';
import logoGloria from "../../assets/logo.png"

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: linear-gradient(to bottom left, #137CEA, #0A3E75);

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    height: 187vw;
  }
`

export const Logo = styled.img`
  max-width: 60%;
  height: auto;
  padding: 40px;
  display: block;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`

export const LogoMobile = styled.img`
  max-width: 70%;
  height: auto;
  padding: 0;
  display: none;
  @media only screen and (max-width: 768px) {
    display: block;
  }
`;

export const FormWrapper = styled.div`
  width: 25%;
  height: 500px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  border-radius: 5px;
  padding: 40px 20px 20px;
  background: #fff;
  &::before {
    content: "";
    display: block;
    width: 175px;
    height: 175px;
    position: absolute;
    top: -21%;
    left: 50%;
    transform: translate(-50%, 0);
    background: url(${ logoGloria }) center center, #fff;
    background-repeat: no-repeat;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, .3);
    border-radius: 50%/50%;
  }

  @media only screen and (max-width: 768px) {
    width: 80%;
    height: 60%;
    &::before {
      width: 120px;
      height: 120px;
      border: 5px solid #fff;
      background-size: cover;
      top: -70px;
    } 
  }



  @media only screen and (min-width: 1367px) {
    width: 20%;
    padding: 20px;
    height: 55vh;
    &::before {
      width: 200px;
      height: 200px;
      top: -110px;
    } 
  }
`;

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
`;